import React, { memo } from 'react';
import { Container } from '@johnlewispartnership/wtr-ingredients/dist/foundations/grid';
import styles from './TopNav.module.scss';
import SpecialistShopsLinks from './SpecialistShopsLinks';
import CustomerServiceLinks from './CustomerServiceLinks';

export const TopNav = memo(() => (
  <nav
    className={`visible-lg-block visible-xl-block visible-xxl-block ${styles.wrapper}`}
    role="navigation"
    aria-label="Top Navigation Bar"
  >
    <Container className={styles.topNavContainer}>
      <div className={`row ${styles.row}`}>
        <SpecialistShopsLinks />
        <CustomerServiceLinks />
      </div>
    </Container>
  </nav>
));
